import api from '../api'

export const channelResource = {
  all () {
    return api().get('/GetChannels')
  },

  find (id) {
    return api().get(`/GetChannel/${id}`)
  },

  create (payload) {
    return api().post('/CreateChannel', payload)
  },

  update (payload) {
    return api().post('/UpdateChannel', payload)
  },

  destroy (id) {
    return api().post(`/DeleteChannel/${id}`)
  },

  addApplication (payload) {
    return api().post('/AddApplicationToChannel', payload)
  },

  updateApplication (payload) {
    return api().post('/UpdateApplicationToChannel', payload)
  }
}
